let generatedData

export const getDonutChartData = (themes) => {
  if (generatedData) {
    generatedData.datasets[0].backgroundColor = [themes['danger'], themes['info'], themes['primary']]
  } else {
    generatedData = {
      labels: ['MISTO', 'CONTAINER', 'GAVETA', 'COMPLETO', 'LP INTEGRAL', 'LP DUPLO'],
      datasets: [{
        label: 'Population (millions)',
        backgroundColor: [themes['danger'], themes['info'], themes['primary'], themes['secondary'], themes['dark', themes['green']]],
        data: [50, 15, 5, 20, 5, 5],
      }],
    }
  }

  return generatedData
}
